var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticClass: "editDialog" },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                disabled: _vm.$route.query.log,
                "label-width": "170px",
              },
            },
            [
              _c("div", { staticClass: "title" }, [_vm._v("资源信息")]),
              _c(
                "div",
                { staticClass: "content" },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "资源分类：", prop: "module" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.$route.query.id,
                                    placeholder: "请选择资源分类",
                                  },
                                  model: {
                                    value: _vm.formData.module,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "module", $$v)
                                    },
                                    expression: "formData.module",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "影视类", value: 1 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "平台类", value: 2 },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "资源状态：", prop: "status" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.formData.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "status", $$v)
                                    },
                                    expression: "formData.status",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("上线"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v("下线"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "乐播媒资 ID：", prop: "id" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$route.query.id || "--") +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "媒资来源：", prop: "partnerId" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择媒资来源" },
                                  model: {
                                    value: _vm.formData.partnerId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "partnerId", $$v)
                                    },
                                    expression: "formData.partnerId",
                                  },
                                },
                                _vm._l(_vm.mediaSourceList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "响应方式：", prop: "skipType" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择响应方式" },
                                  model: {
                                    value: _vm.formData.skipType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "skipType", $$v)
                                    },
                                    expression: "formData.skipType",
                                  },
                                },
                                _vm._l(_vm.skipTypeArr, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "链接（二维码）地址：",
                                prop: "qrCode",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: 999,
                                  placeholder: "请输入链接（二维码）地址",
                                },
                                model: {
                                  value: _vm.formData.qrCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "qrCode", $$v)
                                  },
                                  expression: "formData.qrCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "title" }, [_vm._v("媒资信息")]),
              _c(
                "div",
                { staticClass: "content" },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        color: "#0f40f5",
                        margin: "-15px 0 15px",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: { cursor: "pointer" },
                          on: {
                            click: function ($event) {
                              _vm.mediaInfodialogVisible = true
                            },
                          },
                        },
                        [_vm._v("三方媒资信息")]
                      ),
                    ]
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "媒资名称：", prop: "name" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: 99,
                                  placeholder: "请输入媒资名称",
                                },
                                model: {
                                  value: _vm.formData.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "name", $$v)
                                  },
                                  expression: "formData.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "媒资类型：", prop: "type" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择媒资类型" },
                                  model: {
                                    value: _vm.formData.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "type", $$v)
                                    },
                                    expression: "formData.type",
                                  },
                                },
                                _vm._l(_vm.mediaTypeArr, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "副标题：", prop: "title" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: 999,
                                  placeholder: "请输入副标题",
                                },
                                model: {
                                  value: _vm.formData.title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "title", $$v)
                                  },
                                  expression: "formData.title",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "短描述：", prop: "aword" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: 999,
                                  placeholder: "请输入短描述",
                                },
                                model: {
                                  value: _vm.formData.aword,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "aword", $$v)
                                  },
                                  expression: "formData.aword",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "长描述：", prop: "descr" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入长描述",
                                  type: "textarea",
                                  maxlength: 999,
                                  rows: 4,
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.formData.descr,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "descr", $$v)
                                  },
                                  expression: "formData.descr",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "recommendedTags" } },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("span", [_vm._v("推荐标签：")]),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "top-start",
                                        width: "200",
                                        trigger: "hover",
                                        content:
                                          "服务于App展示媒资内容的推荐标签（搜索结果、榜单等）",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-warning",
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("el-input", {
                                attrs: {
                                  maxlength: 99,
                                  placeholder: "请输入推荐标签",
                                },
                                model: {
                                  value: _vm.formData.recommendedTags,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "recommendedTags",
                                      $$v
                                    )
                                  },
                                  expression: "formData.recommendedTags",
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "标签：", prop: "category" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入标签" },
                                model: {
                                  value: _vm.formData.categoryItem,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "categoryItem", $$v)
                                  },
                                  expression: "formData.categoryItem",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 2 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "20px" },
                              on: { click: _vm.addCategoryItem },
                            },
                            [_vm._v("\n              添加\n            ")]
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 11 } }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-left": "170px" } },
                    _vm._l(_vm.formData.category, function (tag) {
                      return _c(
                        "el-tag",
                        {
                          key: tag,
                          staticStyle: { margin: "0 10px 10px 0" },
                          attrs: { closable: "", "disable-transitions": false },
                          on: {
                            close: function ($event) {
                              return _vm.handleClose(tag, _vm.formData.category)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " + _vm._s(tag) + "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "封面列表：",
                            prop: "vodCoverSaveOrUpdateVO",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: () => _vm.$refs.editCoverRef.show({}),
                              },
                            },
                            [_vm._v("添加")]
                          ),
                        ],
                        1
                      ),
                      _c("cover-list", {
                        attrs: { data: _vm.formData.vodCoverSaveOrUpdateVO },
                        on: {
                          "update:data": function ($event) {
                            return _vm.$set(
                              _vm.formData,
                              "vodCoverSaveOrUpdateVO",
                              $event
                            )
                          },
                          edit: (data) => {
                            _vm.$refs.editCoverRef.show(data)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.formData.module == 1
                ? _c("div", { staticClass: "title" }, [_vm._v("影视媒资信息")])
                : _vm._e(),
              _vm.formData.module == 1
                ? _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "语言：", prop: "language" },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { placeholder: "请选择语言" },
                                      model: {
                                        value: _vm.formData.language,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "language",
                                            $$v
                                          )
                                        },
                                        expression: "formData.language",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: "普通话",
                                          value: "普通话",
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "英文", value: "英文" },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "其他", value: "其他" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 2 } }),
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "地域：", prop: "area" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入地域",
                                      maxlength: 99,
                                    },
                                    model: {
                                      value: _vm.formData.area,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "area", $$v)
                                      },
                                      expression: "formData.area",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "导演名称：",
                                    prop: "director",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入导演名称",
                                      maxlength: 99,
                                    },
                                    model: {
                                      value: _vm.formData.director,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "director", $$v)
                                      },
                                      expression: "formData.director",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 2 } }),
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "上映时间：",
                                    prop: "releaseTime",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      "value-format": "yyyy-MM-dd",
                                      type: "date",
                                      placeholder: "选择上映时间",
                                    },
                                    model: {
                                      value: _vm.formData.releaseTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "releaseTime",
                                          $$v
                                        )
                                      },
                                      expression: "formData.releaseTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "媒体评分：", prop: "score" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入媒体评分",
                                      maxlength: 99,
                                    },
                                    model: {
                                      value: _vm.formData.score,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "score", $$v)
                                      },
                                      expression: "formData.score",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "演员名称：", prop: "actor" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入演员名称" },
                                    model: {
                                      value: _vm.formData.actorItem,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "actorItem", $$v)
                                      },
                                      expression: "formData.actorItem",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 2 } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "20px" },
                                  on: { click: _vm.addActorItem },
                                },
                                [_vm._v("\n              添加\n            ")]
                              ),
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 11 } }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { margin: "0px 0 25px 170px" } },
                        _vm._l(_vm.formData.actor, function (tag) {
                          return _c(
                            "el-tag",
                            {
                              key: tag,
                              staticStyle: { margin: "0 10px 10px 0" },
                              attrs: {
                                closable: "",
                                "disable-transitions": false,
                              },
                              on: {
                                close: function ($event) {
                                  return _vm.handleClose(
                                    tag,
                                    _vm.formData.actor
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " + _vm._s(tag) + "\n          "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "付费模式", prop: "feeMode" },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { placeholder: "请选择付费模式" },
                                      model: {
                                        value: _vm.formData.feeMode,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.formData, "feeMode", $$v)
                                        },
                                        expression: "formData.feeMode",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "免费", value: 0 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "会员免费", value: 1 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "单点付费", value: 2 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "分集解锁", value: 3 },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 2 } }),
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "权益天数：",
                                    prop: "vodDays",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入权益天数",
                                      maxlength: 99,
                                    },
                                    model: {
                                      value: _vm.formData.vodDays,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "vodDays", $$v)
                                      },
                                      expression: "formData.vodDays",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "总集数：",
                                    prop: "totalEpisode",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入总集数",
                                      maxlength: 99,
                                    },
                                    model: {
                                      value: _vm.formData.totalEpisode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "totalEpisode",
                                          $$v
                                        )
                                      },
                                      expression: "formData.totalEpisode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 2 } }),
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "剧集更新：",
                                    prop: "updateEpisode",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入剧集更新" },
                                    model: {
                                      value: _vm.formData.updateEpisode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "updateEpisode",
                                          $$v
                                        )
                                      },
                                      expression: "formData.updateEpisode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "是否完结：", prop: "isEnd" },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { placeholder: "请选择是否完结" },
                                      model: {
                                        value: _vm.formData.isEnd,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.formData, "isEnd", $$v)
                                        },
                                        expression: "formData.isEnd",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "否", value: 0 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "是", value: 1 },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "title" }, [_vm._v("定价信息")]),
              _c(
                "div",
                { staticClass: "content" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "价格呈现：" } },
                    [
                      _c("el-button", { on: { click: _vm.handleAddPice } }, [
                        _vm._v("添加"),
                      ]),
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            placement: "top-start",
                            width: "200",
                            trigger: "hover",
                            content:
                              "按渠道添加价格展示，不添加价格，则媒资不展示价格",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-question",
                            staticStyle: {
                              "margin-left": "20px",
                              width: "10px",
                            },
                            attrs: { slot: "reference" },
                            slot: "reference",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.formData.priceList, border: "" },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "index", label: "No", width: "50" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "channelDesc",
                          label: "渠道",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "useType", label: "价格样式" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(row.useType == "1" ? "原价样式" : "")
                                  ),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(row.useType == "2" ? "现价样式" : "")
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "former", label: "原价" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "now", label: "现价" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(row.now ? row.now : "-")),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "suffix", label: "价格后缀" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(row.suffix ? row.suffix : "-")),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "updateTime", label: "更新时间" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePriceEdit(row.id, row)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePriceDel(row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.$route.query.id
                ? _c("div", { staticClass: "title" }, [_vm._v("分集说明")])
                : _vm._e(),
              _vm.$route.query.id
                ? _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "-20px" },
                          attrs: { label: "添加分集：" },
                        },
                        [
                          _c(
                            "el-button",
                            { on: { click: _vm.episodeListAdd } },
                            [_vm._v("添加")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("avue-crud", {
                            ref: "crud",
                            attrs: {
                              option: _vm.episodeListOption,
                              data: _vm.formData.episodeList,
                            },
                            on: { "sortable-change": _vm.sortDetailChange },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "name",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#3370ff" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.name
                                                ? scope.row.name
                                                : "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "episodeMovie",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#3370ff" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.episodeMovie
                                                ? {
                                                    0: "否",
                                                    2: "是",
                                                  }[
                                                    scope.row.episodeMovie
                                                      .feeMode
                                                  ] ||
                                                    "--" ||
                                                    "-"
                                                : "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "menu",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "_btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleLog(row.id, 2)
                                            },
                                          },
                                        },
                                        [_vm._v("日志")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "_btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleShowImage(
                                                row.playUrl,
                                                "video"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("预览")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "_btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.episodeListEdit(row)
                                            },
                                          },
                                        },
                                        [_vm._v("编辑")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "_btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDetail(row)
                                            },
                                          },
                                        },
                                        [_vm._v("详情")]
                                      ),
                                      row.status === 0
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "_btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.detailOnline(
                                                    row.id,
                                                    1
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("上线")]
                                          )
                                        : _vm._e(),
                                      row.status === 1
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "_btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.detailOnline(
                                                    row.id,
                                                    0
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("下线")]
                                          )
                                        : _vm._e(),
                                      row.addType === 0
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "_btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleDel(row.id)
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              591761721
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.$route.query.id
                ? _c("div", { staticClass: "title" }, [_vm._v("片花")])
                : _vm._e(),
              _vm.$route.query.id
                ? _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "-20px" },
                          attrs: { label: "添加片花：" },
                        },
                        [
                          _c(
                            "el-button",
                            { on: { click: _vm.trailerListAdd } },
                            [_vm._v("添加")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("avue-crud", {
                            ref: "crud",
                            attrs: {
                              option: _vm.trailerListOption,
                              data: _vm.formData.trailerList,
                            },
                            on: {
                              "sortable-change":
                                _vm.trailerListSortDetailChange,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "name",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#3370ff" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.name
                                                ? scope.row.name
                                                : "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "menu",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "_btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleLog(row.id, 3)
                                            },
                                          },
                                        },
                                        [_vm._v("日志")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "_btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleShowImage(
                                                row.playUrl,
                                                "video"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("预览")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "_btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.trailerListEdit(row)
                                            },
                                          },
                                        },
                                        [_vm._v("编辑")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "_btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.trailerListDetail(row)
                                            },
                                          },
                                        },
                                        [_vm._v("详情")]
                                      ),
                                      row.status === 0
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "_btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.trailerListdetailOnline(
                                                    row.id,
                                                    1
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("上线")]
                                          )
                                        : _vm._e(),
                                      row.status === 1
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "_btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.trailerListdetailOnline(
                                                    row.id,
                                                    0
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("下线")]
                                          )
                                        : _vm._e(),
                                      row.addType === 0
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "_btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.trailerListhandleDel(
                                                    row.id
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2215098818
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "right",
                    margin: "40px 0 100px",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.mediaSave },
                    },
                    [_vm._v("保存")]
                  ),
                  _c("el-button", { on: { click: _vm.handleReturnPage } }, [
                    _vm._v("取消"),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm.mediaInfodialogVisible
        ? _c("mediaInfo", {
            attrs: { row: _vm.formData },
            model: {
              value: _vm.mediaInfodialogVisible,
              callback: function ($$v) {
                _vm.mediaInfodialogVisible = $$v
              },
              expression: "mediaInfodialogVisible",
            },
          })
        : _vm._e(),
      _vm.diversityInfodialogVisible
        ? _c("diversityInfo", {
            attrs: {
              sort: _vm.formData.episodeList.length,
              isDisabled: _vm.episodeListDisabled,
              row: _vm.episodeListEditItem,
              partnerId: _vm.formData.partnerId,
            },
            on: { input: _vm.upDataPart },
            model: {
              value: _vm.diversityInfodialogVisible,
              callback: function ($$v) {
                _vm.diversityInfodialogVisible = $$v
              },
              expression: "diversityInfodialogVisible",
            },
          })
        : _vm._e(),
      _vm.trailerInfodialogVisible
        ? _c("trailerInfo", {
            attrs: {
              sort: _vm.formData.trailerList.length,
              isDisabled: _vm.trailerListDisabled,
              row: _vm.trailerListEditItem,
              partnerId: _vm.formData.partnerId,
            },
            on: { input: _vm.upDataPart },
            model: {
              value: _vm.trailerInfodialogVisible,
              callback: function ($$v) {
                _vm.trailerInfodialogVisible = $$v
              },
              expression: "trailerInfodialogVisible",
            },
          })
        : _vm._e(),
      _c("LogDialog", { ref: "logDialog" }),
      _c("PriceDialog", {
        ref: "priceDialog",
        on: {
          updateList: () => {
            _vm.initData()
          },
        },
      }),
      _c("edit-cover", {
        ref: "editCoverRef",
        on: { updateCover: _vm.updateCover },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }